import {
  lazyPipe,
  validateApiRequest,
  validateApiResponse,
  withApiErrorCapture,
} from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import { z } from 'zod';

import { privateHttpClient } from '../httpClient';
import { createApiResponseSchema } from '../utils';
import { AgreementTypeSchema } from './agreement.schemas';
import { agreementApiPath } from './apiPath';

const GetTermsAgreementsResponseDataSchema = z
  .object({
    termsTypes: z.array(AgreementTypeSchema),
  })
  .describe('GetTermsAgreementsResponseDataSchema');

const GetTermsAgreementsResponseSchema = createApiResponseSchema(
  GetTermsAgreementsResponseDataSchema,
);

export type GetTermsAgreementsResponse = z.infer<typeof GetTermsAgreementsResponseSchema>;

export const getTermsAgreements = withApiErrorCapture(
  lazyPipe(
    validateApiRequest(z.void()),
    () =>
      executeStandardRequest(() =>
        privateHttpClient.get<GetTermsAgreementsResponse>(agreementApiPath.getTermsAgreements),
      ),
    validateApiResponse(GetTermsAgreementsResponseSchema),
  ),
);
